/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AddressesRouteImport } from './routes/addresses'
import { Route as PairsRouteImport } from './routes/pairs'
import { Route as PoolsRouteImport } from './routes/pools'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as StatsRouteImport } from './routes/stats'
import { Route as UtxosRouteImport } from './routes/utxos'
import { Route as ArbitragesIndexRouteImport } from './routes/arbitrages.index'
import { Route as ArbitragesHistoryRouteImport } from './routes/arbitrages.history'
import { Route as PoolsIndexRouteImport } from './routes/pools.index'
import { Route as PoolsDexRouteImport } from './routes/pools.$dex'
import { Route as StatsIndexRouteImport } from './routes/stats.index'
import { Route as StatsIdRouteImport } from './routes/stats.$id'
import { Route as StatsLogRouteImport } from './routes/stats.log'
import { Route as StatsPairsPairRouteImport } from './routes/stats.pairs.$pair'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AddressesRoute = AddressesRouteImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => rootRouteImport,
} as any)
const PairsRoute = PairsRouteImport.update({
  id: '/pairs',
  path: '/pairs',
  getParentRoute: () => rootRouteImport,
} as any)
const PoolsRoute = PoolsRouteImport.update({
  id: '/pools',
  path: '/pools',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const StatsRoute = StatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => rootRouteImport,
} as any)
const UtxosRoute = UtxosRouteImport.update({
  id: '/utxos',
  path: '/utxos',
  getParentRoute: () => rootRouteImport,
} as any)
const ArbitragesIndexRoute = ArbitragesIndexRouteImport.update({
  id: '/arbitrages/',
  path: '/arbitrages/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArbitragesHistoryRoute = ArbitragesHistoryRouteImport.update({
  id: '/arbitrages/history',
  path: '/arbitrages/history',
  getParentRoute: () => rootRouteImport,
} as any)
const PoolsIndexRoute = PoolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PoolsRoute,
} as any)
const PoolsDexRoute = PoolsDexRouteImport.update({
  id: '/$dex',
  path: '/$dex',
  getParentRoute: () => PoolsRoute,
} as any)
const StatsIndexRoute = StatsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StatsRoute,
} as any)
const StatsIdRoute = StatsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StatsRoute,
} as any)
const StatsLogRoute = StatsLogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => StatsRoute,
} as any)
const StatsPairsPairRoute = StatsPairsPairRouteImport.update({
  id: '/pairs/$pair',
  path: '/pairs/$pair',
  getParentRoute: () => StatsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/addresses': typeof AddressesRoute
  '/pairs': typeof PairsRoute
  '/pools': typeof PoolsRouteWithChildren
  '/settings': typeof SettingsRoute
  '/stats': typeof StatsRouteWithChildren
  '/utxos': typeof UtxosRoute
  '/arbitrages/history': typeof ArbitragesHistoryRoute
  '/pools/$dex': typeof PoolsDexRoute
  '/stats/$id': typeof StatsIdRoute
  '/stats/log': typeof StatsLogRoute
  '/arbitrages/': typeof ArbitragesIndexRoute
  '/pools/': typeof PoolsIndexRoute
  '/stats/': typeof StatsIndexRoute
  '/stats/pairs/$pair': typeof StatsPairsPairRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/addresses': typeof AddressesRoute
  '/pairs': typeof PairsRoute
  '/settings': typeof SettingsRoute
  '/utxos': typeof UtxosRoute
  '/arbitrages/history': typeof ArbitragesHistoryRoute
  '/pools/$dex': typeof PoolsDexRoute
  '/stats/$id': typeof StatsIdRoute
  '/stats/log': typeof StatsLogRoute
  '/arbitrages': typeof ArbitragesIndexRoute
  '/pools': typeof PoolsIndexRoute
  '/stats': typeof StatsIndexRoute
  '/stats/pairs/$pair': typeof StatsPairsPairRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/addresses': typeof AddressesRoute
  '/pairs': typeof PairsRoute
  '/pools': typeof PoolsRouteWithChildren
  '/settings': typeof SettingsRoute
  '/stats': typeof StatsRouteWithChildren
  '/utxos': typeof UtxosRoute
  '/arbitrages/history': typeof ArbitragesHistoryRoute
  '/pools/$dex': typeof PoolsDexRoute
  '/stats/$id': typeof StatsIdRoute
  '/stats/log': typeof StatsLogRoute
  '/arbitrages/': typeof ArbitragesIndexRoute
  '/pools/': typeof PoolsIndexRoute
  '/stats/': typeof StatsIndexRoute
  '/stats/pairs/$pair': typeof StatsPairsPairRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/addresses'
    | '/pairs'
    | '/pools'
    | '/settings'
    | '/stats'
    | '/utxos'
    | '/arbitrages/history'
    | '/pools/$dex'
    | '/stats/$id'
    | '/stats/log'
    | '/arbitrages/'
    | '/pools/'
    | '/stats/'
    | '/stats/pairs/$pair'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/addresses'
    | '/pairs'
    | '/settings'
    | '/utxos'
    | '/arbitrages/history'
    | '/pools/$dex'
    | '/stats/$id'
    | '/stats/log'
    | '/arbitrages'
    | '/pools'
    | '/stats'
    | '/stats/pairs/$pair'
  id:
    | '__root__'
    | '/'
    | '/addresses'
    | '/pairs'
    | '/pools'
    | '/settings'
    | '/stats'
    | '/utxos'
    | '/arbitrages/history'
    | '/pools/$dex'
    | '/stats/$id'
    | '/stats/log'
    | '/arbitrages/'
    | '/pools/'
    | '/stats/'
    | '/stats/pairs/$pair'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AddressesRoute: typeof AddressesRoute
  PairsRoute: typeof PairsRoute
  PoolsRoute: typeof PoolsRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  StatsRoute: typeof StatsRouteWithChildren
  UtxosRoute: typeof UtxosRoute
  ArbitragesHistoryRoute: typeof ArbitragesHistoryRoute
  ArbitragesIndexRoute: typeof ArbitragesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/addresses': {
      id: '/addresses'
      path: '/addresses'
      fullPath: '/addresses'
      preLoaderRoute: typeof AddressesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pairs': {
      id: '/pairs'
      path: '/pairs'
      fullPath: '/pairs'
      preLoaderRoute: typeof PairsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pools': {
      id: '/pools'
      path: '/pools'
      fullPath: '/pools'
      preLoaderRoute: typeof PoolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stats': {
      id: '/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof StatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/utxos': {
      id: '/utxos'
      path: '/utxos'
      fullPath: '/utxos'
      preLoaderRoute: typeof UtxosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arbitrages/': {
      id: '/arbitrages/'
      path: '/arbitrages'
      fullPath: '/arbitrages/'
      preLoaderRoute: typeof ArbitragesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arbitrages/history': {
      id: '/arbitrages/history'
      path: '/arbitrages/history'
      fullPath: '/arbitrages/history'
      preLoaderRoute: typeof ArbitragesHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pools/': {
      id: '/pools/'
      path: '/'
      fullPath: '/pools/'
      preLoaderRoute: typeof PoolsIndexRouteImport
      parentRoute: typeof PoolsRoute
    }
    '/pools/$dex': {
      id: '/pools/$dex'
      path: '/$dex'
      fullPath: '/pools/$dex'
      preLoaderRoute: typeof PoolsDexRouteImport
      parentRoute: typeof PoolsRoute
    }
    '/stats/': {
      id: '/stats/'
      path: '/'
      fullPath: '/stats/'
      preLoaderRoute: typeof StatsIndexRouteImport
      parentRoute: typeof StatsRoute
    }
    '/stats/$id': {
      id: '/stats/$id'
      path: '/$id'
      fullPath: '/stats/$id'
      preLoaderRoute: typeof StatsIdRouteImport
      parentRoute: typeof StatsRoute
    }
    '/stats/log': {
      id: '/stats/log'
      path: '/log'
      fullPath: '/stats/log'
      preLoaderRoute: typeof StatsLogRouteImport
      parentRoute: typeof StatsRoute
    }
    '/stats/pairs/$pair': {
      id: '/stats/pairs/$pair'
      path: '/pairs/$pair'
      fullPath: '/stats/pairs/$pair'
      preLoaderRoute: typeof StatsPairsPairRouteImport
      parentRoute: typeof StatsRoute
    }
  }
}

interface PoolsRouteChildren {
  PoolsDexRoute: typeof PoolsDexRoute
  PoolsIndexRoute: typeof PoolsIndexRoute
}

const PoolsRouteChildren: PoolsRouteChildren = {
  PoolsDexRoute: PoolsDexRoute,
  PoolsIndexRoute: PoolsIndexRoute,
}

const PoolsRouteWithChildren = PoolsRoute._addFileChildren(PoolsRouteChildren)

interface StatsRouteChildren {
  StatsIdRoute: typeof StatsIdRoute
  StatsLogRoute: typeof StatsLogRoute
  StatsIndexRoute: typeof StatsIndexRoute
  StatsPairsPairRoute: typeof StatsPairsPairRoute
}

const StatsRouteChildren: StatsRouteChildren = {
  StatsIdRoute: StatsIdRoute,
  StatsLogRoute: StatsLogRoute,
  StatsIndexRoute: StatsIndexRoute,
  StatsPairsPairRoute: StatsPairsPairRoute,
}

const StatsRouteWithChildren = StatsRoute._addFileChildren(StatsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AddressesRoute: AddressesRoute,
  PairsRoute: PairsRoute,
  PoolsRoute: PoolsRouteWithChildren,
  SettingsRoute: SettingsRoute,
  StatsRoute: StatsRouteWithChildren,
  UtxosRoute: UtxosRoute,
  ArbitragesHistoryRoute: ArbitragesHistoryRoute,
  ArbitragesIndexRoute: ArbitragesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
